const ROUTES_PATH = {
  LOG_IN: "/login",
  FORGOT_PASSWORD: "/forgotpassword",
  RESET_PASSWORD: "/resetpassword",
  DASHBOARD: "/admin",
};
export default ROUTES_PATH;
